import React from 'react';
import styles from '../styles/Mission.module.css';

const Mission: React.FC = () => {
  return (
    <div>
      <p className={styles.title}>About Our Mission</p>
      <p className={styles.mainText}>Split Heritage is a non-profit organization that supports and celebrates the incredible heritage of Split art in the territories of the Roman Empire, which in its greatest expansion included part of present-day Dalmatia.</p>
    </div>
  );
};

export default Mission;